/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountGrid extends SiteEntityGrid<AccountRow, any> {
        protected getColumnsKey() { return 'Data.Account'; }
        protected getDialogType() { return AccountDialog; }
        protected getIdProperty() { return AccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRow.localTextPrefix; }
        protected getService() { return AccountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}